import { getApiErrorMessage } from './apiError';

export function validateTrainingFile(file: File, kind: 'video' | 'presentation' | 'transcript'): string | null {
  const extension = kind === 'video' ? /\.(mp4|webm)$/i : kind === 'presentation' ? /\.pdf$/i : /\.txt$/i;
  if (!extension.test(file.name)) return kind === 'video' ? 'Выберите MP4 или WebM' : kind === 'presentation' ? 'Выберите PDF' : 'Выберите TXT';
  const limit = kind === 'video' ? 4096 : kind === 'presentation' ? 100 : 5;
  if (file.size > limit * 1024 * 1024) return `Файл «${file.name}» превышает лимит ${limit} МБ`;
  if (!file.size) return 'Выберите непустой файл';
  return null;
}

export function trainingUploadError(error: any, fallback: string): string {
  if (error?.response?.status === 413) return 'Сервер отклонил загрузку: файл превышает допустимый размер.';
  if (typeof error?.response?.data === 'string' && /<\/?(?:html|body|head)[\s>]/i.test(error.response.data)) return fallback;
  return getApiErrorMessage(error, fallback);
}
